export const CURRENCY = "ريال";
export const TOTAL = "الاجمالي";
export const TITLE = "رسوم الدفع والتوصيل";
export const TABLE_ITEMS = {
  DELIVERY_FEES: "التوصيل",
  NET_PRICE: "التكلفة الرئيسية",
  WAFFY_FEES: "رسوم خدمة وفي",
};
export const CONTRACT_DETAILS = "تفاصيل المنتج / الخدمة";
export const ADDITIONIAL_INFO = "تفاصيل اضافية";
export const CONTRACT_STATUS = "حالة المعاملة";
export const RECEIVER_INFO = "معلومات المشتري";
export const SENDER_INFO = "معلومات البائع";

export const BACK_BUTTON_LABEL = "الرجوع للصفحة السابقة";
export const SHIPMENT_METHOD = "وسيلة الشحن";
export const FEES = "الرسوم";
export const DELIVERY_PERIOd = "مدة التوصيل";
export const EXAMINATION_PERIOD = "مدة الفحص";
export const GALLERY = "الصور الخاصة بالمنتج";
export const NUMBER = "رقم";
export const DATE = "تاريخ";
export const PROVIDER = "البائع";
export const CUSTOMER = "المشتري";
export const COPY_URL = "نسخ رابط المعاملة";

export const APPROVE_AND_FINISH = "تأكيد و انهاء المعاملة";
export const ESCALATE_TO_WAFFY = "التصعيد لوفي";
export const APPROVE_DELIVERY = "تأكيد استلام المنتج";
export const DO_YOU_HAVE_ANY_PROBLEM = "هل تواجه مشكلة";
export const ADDITIONAL_REASONS = "اسباب اخري";
export const WRITE_REASONS = "اكتب اسباب الرفض";

export const SHIPMENT_COMPANY = "شركة شحن";
export const NO_SHIPMENT_COMPANY = "لا توجد شركة شحن";

export const AUTHENTICATION_THROUGH_PINCODE_TITLE = "قم بادخال رمز الامان";
export const APPROVE_DELIVERY_SUB_TITLE = "أدخل رمز الأمان لتأكيد الاستلام";
export const DELETE_SUB_TITLE = "أدخل رمز الأمان لتأكيد المسح";
export const DELETE_MODAL_DESCRIPTION =
  "عند تأكيدك لحذف المعاملة لا تتمكن من الرجوع إليها وسيتم إزالة الرابط الخاص بها";
export const DELETE_MODAL_BUTTONS = {
  CANCEL: "لا، إبقاء معاملتي",
  DELETE: "نعم، أريد حذفها",
};
export const CONFIRMATION_MODAL_TITLE = {
  ADMIN_DELETE_ITEM: "هل انت متأكد من حذف المعاملة؟",
};
export const CONFIRMATION_MODAL_DESCRIPTION = {
  APPROVE_DELIVERY: "هل تريد تاكيد استلام المنتج؟",
  ADMIN_CLOSE_REFUND_CUSTOMER_REFUND_BUYER:
    "هل تريد تاكيد ارجاع المبلغ المستحق للمشتري؟",
  RELEASE_FUND_TO_SELLER: "هل تريد ارسال المبلغ المستحق للبائع؟",
  ADMIN_RESOLVE_ESCALATION: "هل تريد اقتراح تسوية لهذا النزاع؟",
  ADMIN_RESOLVE_ESCALATION_REFUND_CUSTOMER:
    "هل تريد حل المعاملة بارسال المبلغ للمشتري؟",
  ADMIN_RESOLVE_ESCALATION_RELEASE_PROVIDER:
    "هل تريد حل المعاملة بارسال المبلغ للبائع",
  ADMIN_CLOSE_REFUND_CUSTOMER: "هل تريد تاكيد ارسال المبلغ للمشتري؟",
  ADMIN_CLOSE_RELEASE_FUND_TO_PROVIDER: "هل تريد تاكيد ارسال المبلغ للبائع",
  ADMIN_COMPLETE_RELEASE_FUND_TO_PROVIDER: "هل تريد تاكيد ارسال المبلغ للبائع",
  ADMIN_ACCEPT_ITEM: "هل تريد تاكيد فحص المنتج؟",
  ADMIN_DELETE_ITEM: "عند تأكيدك لحذف المعاملة لن تتمكن من الرجوع اليها",
};
export const CONFIRMATION_MODAL_BUTTONS = {
  CANCEL: "الغاء",
  CONFIRM: "تاكيد",
  DELETE: "نعم، اريد حذفها",
  CANCEL_DELETE: "لا، إبقاء المعاملة",
};
export const APPROVE_INSPECTION_SUB_TITLE = "أدخل رمز الأمان لتأكيد الفحص";
export const ARE_YOU_SURE_WANT_TO_DELETE_THIS_CONTRACT =
  "هل انت متأكد من حذف المعاملة؟";
export const VERIFY_PIN_CODE_ERROR = "خطأ في رمز الأمان";
export const CANNOT_MAKE_THIS_CALL = "لا يمكنك اتمام هذة المعاملة";
export const ACTION_UNDER_PROCESSING = "طلبك قيد التنفيذ";
export const SELECT_PROBLEMS_YOU_ARE_FACING = "قم بتحديد المشاكل التي تواجهك";
export const DELETED_SUCCESSFULLY = "تم مسح المعاملة بنجاح";
export const CANNOT_BE_DELETED = "لا يمنك مسح هذة المعاملة";
export const APPROVE_AND_FINISH_BUTTON_STYLE = {
  backgroundColor: "#078DE7",
  color: "#FFFFFF",
};
export const ESCALATE_TO_WAFFY_BUTTON_STYLE = {
  backgroundColor: "#F3F4F5",
  color: "#404D58",
};

export const APPROVE_DELIVERY_BUTTON_STYLE = {
  backgroundColor: "#078DE7",
  color: "#FFFFFF",
};
export const DO_YOU_HAVE_ANY_PROBLEM_BUTTON_STYLE = {
  backgroundColor: "#F3F4F5",
  color: "#404D58",
};

export const COPY_URL_BUTTON_STYLE = {
  background: "#283743",
};
export const DELETE_BUTTON_STYLE = {
  color: "#EB4C43",
};
export const LOGIN_SECTION_ID = "loginId";
